export function BrandLogo({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand-lockup ${compact ? "compact" : ""}`} aria-label="昆明米纳海进出口贸易有限公司">
      <span className="brand-company-cn">昆明米纳海进出口贸易有限公司</span>
      <span className="brand-company-en">KUNMING MINAHAI IMPORT &amp; EXPORT TRADING CO., LTD.</span>
    </div>
  );
}
